export default class Map {
    static init() {
        // Ignore if not in Neos backend
        if (!window?.neos?.guestFrame?.findElementByNode) {
            return;
        }

        document.addEventListener('Neos.NodeCommit', (event) => {
            const {node, property} = event.detail;

            if (node.nodeType !== 'CodeQ.Site:Content.Map.Item') {
                return;
            }

            this.updateMapItem(node, property)
        })

        document.addEventListener('Neos.NodeDiscard', (event) => {
            const {node, properties} = event.detail;

            if (node.nodeType !== 'CodeQ.Site:Content.Map.Item') {
                return;
            }

            properties.forEach(property => {
                this.updateMapItem(node, property)
            })
        })
    }

    static updateMapItem(node, property) {
        const element = window.neos.guestFrame.findElementByNode(node)
        const {name, updated} = property
        switch(name) {
            case 'horizontalPosition': element.style.left = updated/10+"%"; break;
            case 'verticalPosition': element.style.top = updated/10+"%"; break;
        }
    }
}
